import React from "react";

export function DummyModule() {
    return (
        <div>
            DUMMY MODULE
        </div>
    );
}